<template>
  <cTable
    :fields="fields"
    :header="header"
    :methods="methods"
    :modals="modals"
    :config="config"
    :footer="footer"
    ref="table"
  >
  </cTable>
</template>

<script>
import cTable from "@/base/common/index";
import { apis } from "@/api/finance/segmentDetails";
import { bayan } from "@/api/extract/list";

export default {
  name: "",
  components: {
    cTable
  },
  data() {
    return {
      methods: {
        ...apis,
        list: apis.tmExtractList,
        beforeHandleList({ data }) {
          data.rows.forEach(t => {
            t.fee_list.total_fee += " " + t.fee_list.currency;
            return t;
          });
          return data.rows;
        },
        bayan
      },
      config: {},
      footer: {},
      modals: {
        bayan: {
          config: {
            isNoPage: true,
            listFn: "bayan",
            title: this.$tz("bayan,文件"),
            modalBind: {
              width: 1000
            }
          },
          footer: {
            show: () => false
          },
          table: {
            config: {
              height: 600
            },
            fields: [
              {
                name: () => this.$tz("文件,名称"),
                key: "title",
                minWidth: 110
              },
              {
                name: () => this.$tz("操作人"),
                key: "create_name",
                minWidth: 110
              },
              {
                name: () => this.$tz("上传,时间"),
                key: "create_time",
                minWidth: 110
              },
              {
                name: () => this.$t("operation"),
                type: "btns",
                width: 220,
                fixed: "right",
                list: [
                  {
                    name: this.$tz("下载"),
                    type: "down",
                    fnName: "down",
                    bind: {
                      type: "primary"
                    },
                    id: ""
                  }
                ],
                methods: {
                  down({ row }) {
                    window.open(row.src, "_blank");
                  }
                }
              }
            ]
          }
        },
        number: {
          config: {
            title: this.$tz("明细"),
            modalBind: {
              width: 1000
            },
            listFn: "shipmentDetails"
          },
          footer: {
            show: () => false
          },
          table: {
            config: {
              height: 600
            },
            header: {
              searchs: [
                {
                  key: "keywords",
                  placeholder() {
                    return this.$t("keyword");
                  },
                  component: "Input",
                  bind: {
                    type: "textarea",
                    autosize: { minRows: 2, maxRows: 2 }
                  }
                }
              ]
            },
            footer: {
              show: () => true
            },
            fields: [
              {
                name: () => this.$tz("袋子号"),
                key: "package_number",
                minWidth: 130
              },
              {
                name: () => this.$tz("订单号"),
                key: "airway_number",
                minWidth: 130
              },
              {
                name: () => this.$tz("入库重量"),
                key: "check_weight",
                minWidth: 130
              },
              {
                name: () => this.$tz("申报价值"),
                key: "values",
                minWidth: 130
              },
              {
                name: () => this.$tz("起运国"),
                key: "from_country",
                minWidth: 130
              },
              {
                name: () => this.$tz("目的国"),
                key: "to_country",
                minWidth: 130
              },
              {
                name: () => this.$tz("客户,原单号"),
                key: "client_refer_code",
                minWidth: 130
              }
            ]
          }
        }
      },
      header: {
        searchs: [
          {
            key: "customer_id",
            placeholder() {
              return this.$tz("客户");
            },
            component: "Select",
            options: [],
            optionsFn: "customer",
            optionsKey: ""
          },
          {
            key: "keywords",
            placeholder() {
              return this.$t("keyword");
            },
            component: "Input",
            bind: {
              type: "textarea",
              autosize: { minRows: 2, maxRows: 2 }
            }
          }
        ],
        btns: {
          list: [
            {
              name: () => this.$tz("导出"),
              type: "export",
              fnName: "export",
              bind: {
                type: "primary"
              },
              disabled() {
                return this.selectAll.length == 0;
              }
            }
          ],
          methods: {
            export() {
              this.exportExc();
            }
          }
        }
      },
      fields: [
        {
          type: "checkbox",
          width: 50,
          fixed: "left",
          align: "center"
        },
        {
          name: () => this.$tz("提单号"),
          key: "mawb",
          minWidth: 130,
          fixed: "left"
        },
        {
          name: () => this.$tz("客户代码"),
          key: "client_info.client_account",
          minWidth: 110
        },
        {
          name: () => this.$tz("所属公司"),
          key: "client_info.ownership_name",
          minWidth: 110
        },
        {
          name: () => this.$tz("航班"),
          key: "flight",
          minWidth: 130
        },
        {
          name: () => this.$tz("清关,时间"),
          key: "clearance_date",
          minWidth: 110
        },
        {
          name: () => this.$tz("提单,重量"),
          key: "weight",
          minWidth: 130
        },
        {
          name: () => this.$tz("目的地"),
          key: "to_station",
          minWidth: 130
        },
        {
          name: () => this.$tz("包裹,总,重量"),
          key: "check_weight",
          minWidth: 130
        },
        {
          name: () => this.$tz("包裹,数量"),
          key: "nums",
          minWidth: 130,
          component: "Button",
          bind: {
            type: "primary",
            size: "small"
          },
          disabled: ({ value }) => !value,
          methods: {
            click({ row }) {
              console.log(row);
              this.$page.getModal("number").open(row, function() {
                this.pageConfig.data = { id: row.id };
                this.setTitle(`${this.$tz("明细")}(${row.mawb})`);
                this.getList();
              });
            }
          }
        },
        {
          name: () => this.$tz("包裹,申报价值"),
          key: "values",
          minWidth: 110
        },
        {
          name: () => this.$tz("提单,清关费"),
          key: "fee_list.td_clearance_fee",
          minWidth: 130
        },
        {
          name: () => this.$tz("包裹,清关费"),
          key: "fee_list.bg_clearance_fee",
          minWidth: 130
        },
        {
          name: () => this.$tz("操作费"),
          key: "fee_list.handling_fee",
          minWidth: 130
        },
        {
          name: () => this.$tz("其他费用"),
          key: "fee_list.other_fee",
          minWidth: 110
        },
        {
          name: () => this.$tz("合计"),
          key: "fee_list.total_fee",
          minWidth: 110,
          fixed: "right"
        },
        {
          name: () => this.$t("operation"),
          type: "btns",
          width: 220,
          fixed: "right",
          list: [
            {
              name: this.$tz("提单,导出"),
              type: "mawb",
              fnName: "export",
              bind: {
                type: "primary"
              },
              id: ""
            },
            {
              name: () => this.$tz("包裹,导出"),
              type: "package",
              fnName: "export",
              bind: {
                type: "primary"
              }
            },
            {
              name: () => this.$tz("bayan"),
              type: "bayan",
              bind: {
                type: "primary"
              },
              fnName: "bayan"
            }
          ],
          methods: {
            export({ row, field }) {
              this.handleRequestMethods(
                field.type == "package" ? "bgTdExportV2" : "tdExportV2",
                { id: row.id },
                true,
                true
              ).then(res => {
                console.log(res);
                window.open(this.$globalUrl + res.payload, "_blank");
              });
            },
            bayan({ row }) {
              this.getModal("bayan").open(row, function() {
                this.setTitle(this.$tz("bayan"));
                this.pageConfig.data.id = row.id;
                this.pageConfig.data.type = 2;
                this.getList();
              });
            }
          }
        }
      ]
    };
  }
};
</script>

<style scoped></style>
